import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container", "item"]

  add(event) {
    event.preventDefault()
    
    // Get template content
    const content = this.templateTarget.content.cloneNode(true)
    
    // Get the next available index
    const nextIndex = this.getNextIndex()
    const newContent = content.querySelector('*').outerHTML.replace(/NEW_RECORD/g, nextIndex)
    
    // Add the new item to the container
    this.containerTarget.insertAdjacentHTML('beforeend', newContent)
    document.dispatchEvent(new CustomEvent("default-memory:dynamic-row-added", {
      detail: {
        association: "invoice_vat_lines_attributes",
        fromIndex: "NEW_RECORD",
        toIndex: nextIndex
      }
    }))
  }

  remove(event) {
    event.preventDefault()
    const vatLine = event.currentTarget.closest('.vat-line')
    vatLine.style.display = 'none'
    // Mark for deletion when form is submitted
    const destroyInput = vatLine.querySelector('input[name*="_destroy"]')
    if (destroyInput) destroyInput.value = '1'
  }

  getNextIndex() {
    // Get all existing VAT line inputs
    const inputs = document.querySelectorAll('input[name*="[invoice_vat_lines_attributes]"]')
    let maxIndex = -1

    // Find the highest index currently in use
    inputs.forEach(input => {
      const match = input.name.match(/\[invoice_vat_lines_attributes\]\[(\d+)\]/)
      if (match) {
        const index = parseInt(match[1])
        maxIndex = Math.max(maxIndex, index)
      }
    })

    return maxIndex + 1
  }
}
